module.exports = __webpack_public_path__ + "static/media/leaf.774d36ed.png";